import Page from '../contato/faq'
export default Page
